// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3AxEn","colBig":"styles_colBig__3oGfw","colSmall":"styles_colSmall__2PSH0"};